module.exports = __webpack_public_path__ + "static/media/undraw_all-the-data_ijgn.6aa39852.svg";